import { Flex, useColorMode } from '@chakra-ui/core';
import React from 'react';

const ConfigPanel = () => {
    const { colorMode } = useColorMode();
    const color = { light: 'gray.900', dark: 'gray.100' };

    return (
        <Flex position="relative" direction="column" maxH="100vh" color={color[colorMode]} w="100%" overflow="hidden">
            Config Panel
        </Flex>
    );
};

export default ConfigPanel;
